var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseLightbox = function SvgCloseLightbox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 .5C11 .5.5 11 .5 24S11 47.5 24 47.5 47.5 37 47.5 24 37 .5 24 .5zm6 28.1c.4.4.4 1 0 1.4-.2.2-.5.3-.7.3s-.5-.1-.7-.3L24 25.4 19.4 30c-.2.2-.5.3-.7.3s-.5-.1-.7-.3c-.4-.4-.4-1 0-1.4l4.6-4.6-4.6-4.6c-.4-.4-.4-1 0-1.4s1-.4 1.4 0l4.6 4.6 4.6-4.6c.4-.4 1-.4 1.4 0s.4 1 0 1.4L25.4 24l4.6 4.6z"
  })));
};
export default SvgCloseLightbox;